// The order customers fill in an invitation's details (Ezriel, 2026-10-08), on every template:
// Week, Day, Place type, Address, Time, Your name, Father's name, Shvair's name.
// Same order as the phone and SMS questions (backend app/core/field_order.py).

export const FIELD_ROLES = ['week', 'day', 'place', 'address', 'time', 'name', 'father', 'shvair'];

// Checked in this order: "Father's Name" and "Shvair's Name" also contain "name".
const ROLE_PATTERNS = [
  ['shvair', /shva?ir|shver|in[- ]?law/i],
  ['father', /father/i],
  ['week', /week|parsh|sedr/i],
  ['day', /\bday\b/i],
  ['time', /\btime\b|\bhour/i],
  ['address', /^(?!.*e-?mail).*(address|street)/i], // not "Email Address"
  ['place', /place|location|venue|\bhall\b/i],
  ['name', /name/i],
];

/** The detail a template line asks for (one of FIELD_ROLES), or null for fixed wording and custom lines. */
export const fieldRole = (field) => {
  if (!field || field.custom || field.static) return null;
  const label = field.label || '';
  for (const [role, re] of ROLE_PATTERNS) if (re.test(label)) return role;
  return null;
};

/** Detail lines in the agreed order first, then every other line in its original order. */
export const orderFields = (fields = []) =>
  fields
    .map((f, i) => {
      const role = fieldRole(f);
      return { f, rank: role ? FIELD_ROLES.indexOf(role) : FIELD_ROLES.length + i };
    })
    .sort((a, b) => a.rank - b.rank)
    .map(({ f }) => f);
